import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFire, faMusic } from '@fortawesome/free-solid-svg-icons';
import './EventOverview.css';

const EventOverview = ({ events = [] }) => {
  if (events.length === 0) return null;

  return (
    <section className="event-overview-section">
      <div className="event-overview-container">
        <h2 className="section-title">Upcoming Events</h2>
        
        {events.map((event, index) => (
          <div key={event.id} className="event-section">
            <div className="event-overview-content">
              {/* Left: Text Content */}
              <div className="event-text">
                <h3 className="event-name">{event.title}</h3>
                <p className="event-subtitle-text">{event.subtitle}</p>
                <div className="event-description">
                  <p>{event.description}</p>
                  <p>
                    Experience premium sound, stunning visuals, and an incredible atmosphere at The Retro Street. 
                    Don't miss out on this spectacular night of music, celebration, and memories that will last a lifetime!
                  </p>
                </div>
                <div className="event-highlights">
                  <div className="highlight-item">
                    <FontAwesomeIcon icon={faMusic} className="highlight-icon" />
                    <span>Live DJ Performance</span>
                  </div>
                  <div className="highlight-item">
                    <FontAwesomeIcon icon={faFire} className="highlight-icon" />
                    <span>High-Energy Atmosphere</span>
                  </div>
                </div>
              </div>

              {/* Right: Event Image */}
              <div className="event-image-wrapper">
                <div className="event-image-container">
                  <img src={event.imageUrl || event.image} alt={event.title} className="event-image" />
                  <div className="event-badge">
                    <FontAwesomeIcon icon={faFire} className="badge-icon" /> {event.djName}
                  </div>
                </div>
              </div>
            </div>
            {index < events.length - 1 && <div className="event-divider"></div>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default EventOverview;
